import { getApiBaseUrl } from '../utils/env';

const devBaseUrl = 'http://192.168.1.116:4523/m1/2943796-0-default'; //开发环境

interface statusCode {
  [propName: number]: string;
}

export const statusCode: statusCode = {
  // 2xx 成功
  200: '服务器成功返回请求的数据',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）',
  204: '删除数据成功',
  206: '部分请求成功(206)',
  // 3xx 重定向
  301: '资源已永久移动(301)',
  302: '资源已临时移动(302)',
  303: '请使用 GET 访问目标资源(303)',
  304: '资源未修改，可使用缓存(304)',
  307: '资源临时重定向(307)',
  308: '资源永久重定向(308)',
  // 4xx 客户端错误
  400: '请求错误(400)',
  401: '未授权，缺少令牌',
  403: '拒绝访问(403)',
  404: '请求出错(404)',
  405: '请求方法不被允许(405)',
  406: '请求的格式不可得(406)',
  407: '需要代理授权(407)',
  408: '请求超时(408)',
  409: '请求发生冲突(409)',
  410: '请求的资源已删除(410)',
  411: '需要 Content-Length 头(411)',
  412: '请求前置条件失败(412)',
  413: '请求实体过大(413)',
  414: '请求的 URI 过长(414)',
  415: '不支持的媒体类型(415)',
  416: '请求的范围无效(416)',
  417: '期望值失败(417)',
  422: '请求参数校验失败(422)',
  423: '资源被锁定(423)',
  424: '依赖的请求失败(424)',
  426: '需要升级协议(426)',
  428: '请求缺少前置条件(428)',
  429: '请求过于频繁，请稍后再试(429)',
  431: '请求头字段过大(431)',
  451: '因法律原因拒绝访问(451)',
  // 5xx 服务器错误
  500: '服务器错误(500)',
  501: '服务未实现(501)',
  502: '网络错误(502)',
  503: '服务不可用(503)',
  504: '网络超时(504)',
  505: 'HTTP 版本不受支持(505)',
  506: '协商变体错误(506)',
  507: '存储空间不足(507)',
  508: '检测到循环请求(508)',
  511: '需要进行网络认证(511)'
};

export const BASE_URL = getApiBaseUrl();
export const TIMEOUT = 30000;
